/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/images/pokedex/angular-structure.png",
        "alt": "Estructura de archivos de Angular"
      }}></img></p>
    <p>{`La estructura de carpetas en Angular parece más compleja a primera vista sin embargo contiene más herramientas y funcionalidades al momento de crear el proyecto con el CLI.`}</p>
    <p>{`Contamos con una carpeta `}<em parentName="p">{`e2e`}</em>{` donde se incluyen todos los archivos y configuraciones necesarias para realizar End To End Testing, aparte todos los componentes se crean con un archivo `}<inlineCode parentName="p">{`.spect.ts`}</inlineCode>{` para realizar Unit Testing.`}</p>
    <p>{`En la raíz del proyecto podemos encontrar varios archivos `}<inlineCode parentName="p">{`json`}</inlineCode>{` para la configuración de TypeScript y Angular. Entre ellos podemos encontrar `}<inlineCode parentName="p">{`angular.json`}</inlineCode>{` donde viene el especificado el `}<inlineCode parentName="p">{`path`}</inlineCode>{` del template html, el `}<inlineCode parentName="p">{`favicon`}</inlineCode>{`, los assets del proyecto así como el linter y otras configuraciones.`}</p>
    <p>{`Otra carpeta que genera el CLI es enviroments donde viene especificada la configuración del ambiente de desarrollo y de producción.`}</p>
    <p>{`El último detalle es que hay archivos para implementar servicios como peticiones HTTP.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;